import z from 'zod';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import dayjs from 'dayjs';
import { KuendigungsGrund } from '@/domain/vertraege/shared/types/kuendigungsGrund';
import { TFunction } from 'i18next';
dayjs.extend(isSameOrAfter);

export function useSchema({ t }: { t: TFunction<'translation', undefined> }) {
  const formSchema = z.object({
    vorname: z.string(),
    nachname: z.string(),
    unternehmen: z.string(),
    vertragsnummer: z.string(),
    kundennummer: z.string(),
    email: z.string(),
    telefon: z
      .string()
      .min(1, {
        message: t('domain.vertraege.kuendigenForm.fields.telefon.required'),
      })
      .regex(
        /^[^A-Za-z]*$/,
        t('domain.vertraege.kuendigenForm.fields.telefon.onlyNumbers'),
      ),
    kuendigungZum: z
      .date({
        message: t(
          'domain.vertraege.kuendigenForm.fields.kuendigungZum.required',
        ),
      })
      .refine((value) => dayjs(value).isSameOrAfter(dayjs().toDate(), 'day'), {
        message: t(
          'domain.vertraege.kuendigenForm.fields.kuendigungZum.isNotSameOrAfter',
        ),
      }),
    grund: z.nativeEnum(KuendigungsGrund, {
      message: t('domain.vertraege.kuendigenForm.fields.grund.required'),
    }),
    beschreibung: z.string(),
  });

  return formSchema;
}
